import { useState } from 'react';

export default function RefundForm() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    plan: '',
    sns_link: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('plan', formData.plan);
      formBody.append('sns_link', formData.sns_link);

      const response = await fetch('https://readdy.ai/api/form/d5vpoer0o41p73074280', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', plan: '', sns_link: '' });
        setTimeout(() => {
          setSubmitStatus('idle');
          setIsModalOpen(false);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    setSubmitStatus('idle');
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSubmitStatus('idle');
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div 
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={closeModal}
          ></div>
          
          <div className="relative bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border-2 border-[#14B8A6]/30 rounded-3xl p-8 w-full max-w-[500px] max-h-[90vh] overflow-y-auto animate-[fadeIn_0.3s_ease-out]">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-[24px]"></i>
            </button>

            <div className="text-center mb-8">
              <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6]/20 to-[#0D9488]/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-gift-line text-[28px] text-[#14B8A6]"></i>
              </div>
              <h3 className="text-[28px] font-bold text-white mb-2">환급 이벤트 신청</h3>
              <p className="text-[14px] text-gray-400">아래 정보를 입력해주세요</p>
            </div>

            <form id="refund-event-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-[14px] font-semibold text-white mb-2">이름 *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full bg-[#0F0F0F] border border-gray-700 rounded-xl px-4 py-3 text-[14px] text-white focus:border-[#14B8A6] focus:outline-none transition-colors"
                  placeholder="이름을 입력하세요"
                />
              </div>

              <div>
                <label className="block text-[14px] font-semibold text-white mb-2">이메일 *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full bg-[#0F0F0F] border border-gray-700 rounded-xl px-4 py-3 text-[14px] text-white focus:border-[#14B8A6] focus:outline-none transition-colors"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label className="block text-[14px] font-semibold text-white mb-2">연락처 *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  className="w-full bg-[#0F0F0F] border border-gray-700 rounded-xl px-4 py-3 text-[14px] text-white focus:border-[#14B8A6] focus:outline-none transition-colors"
                  placeholder="010-0000-0000"
                />
              </div>

              <div>
                <label className="block text-[14px] font-semibold text-white mb-2">수강 플랜 *</label>
                <select
                  name="plan"
                  value={formData.plan}
                  onChange={(e) => setFormData({ ...formData, plan: e.target.value })}
                  required
                  className="w-full bg-[#0F0F0F] border border-gray-700 rounded-xl px-4 py-3 text-[14px] text-white focus:border-[#14B8A6] focus:outline-none transition-colors cursor-pointer"
                >
                  <option value="">플랜을 선택하세요</option>
                  <option value="베이직">LEXO Basic</option>
                  <option value="스마트">LEXO Smart</option>
                  <option value="프로">LEXO Pro</option>
                </select>
              </div>

              <div>
                <label className="block text-[14px] font-semibold text-white mb-2">SNS 인증 링크 *</label>
                <input
                  type="url"
                  name="sns_link"
                  value={formData.sns_link}
                  onChange={(e) => setFormData({ ...formData, sns_link: e.target.value })}
                  required
                  className="w-full bg-[#0F0F0F] border border-gray-700 rounded-xl px-4 py-3 text-[14px] text-white focus:border-[#14B8A6] focus:outline-none transition-colors"
                  placeholder="https://..."
                />
                <p className="text-[12px] text-gray-400 mt-1.5">수강 완료 인증샷을 올린 SNS 게시물 링크</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-[#14B8A6]/10 border border-[#14B8A6] rounded-xl p-4 flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-[22px] text-[#14B8A6]"></i>
                  <p className="text-[14px] text-[#14B8A6] font-semibold">신청이 완료되었습니다!</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/10 border border-red-500 rounded-xl p-4 flex items-center gap-3">
                  <i className="ri-error-warning-line text-[22px] text-red-500"></i>
                  <p className="text-[14px] text-red-500 font-semibold">오류가 발생했습니다. 다시 시도해주세요.</p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-[16px] font-bold py-4 rounded-xl hover:shadow-[0_0_30px_rgba(20,184,166,0.4)] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer mt-2"
              >
                {isSubmitting ? '신청 중...' : '신청하기'}
              </button>
            </form>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
      `}</style>
    </>
  );
}
